var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 480,
    width: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M-95.808-.44h682.67v512h-682.67z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(89.82 .412) scale(.9375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M610.61 511.56h-730.17v-512h730.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.871 256.021c0 62.137-50.372 112.508-112.507 112.508-62.137 0-112.507-50.372-112.507-112.508 0-62.137 50.371-112.507 112.507-112.507 62.137 0 112.507 50.372 112.507 112.507z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.011 262.55c0 81.079-65.034 146.803-145.261 146.803S102.488 343.63 102.488 262.55s65.034-146.804 145.262-146.804S393.01 181.471 393.01 262.55z",
    fill: "#c70000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49.417 126.44l83.66-96.77 19.821 17.135-83.66 96.771zM-22.018 150.127l83.66-96.77 19.82 17.135-83.66 96.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49.417 126.44l83.66-96.77 19.821 17.135-83.66 96.771z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49.417 126.44l83.66-96.77 19.821 17.135-83.66 96.771zM5.967 174.32l83.66-96.77 19.82 17.136-83.66 96.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49.417 126.44l83.66-96.77 19.821 17.135-83.66 96.771z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49.417 126.44l83.66-96.77 19.821 17.135-83.66 96.771zM459.413 29.638l83.002 97.335-19.937 17-83.002-97.334zM403.707 77.141l83.002 97.335-19.936 17-83.002-97.334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.55 133.19l78.602-67.814 14.641 16.953-83.996 75.519-9.247-24.659z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.228 372.013l-80.416 95.829-19.716-16.4 80.417-95.828zM431.853 53.14l83.002 97.334-19.936 17.001-83.002-97.334zM541.475 394.676l-80.417 95.829-19.715-16.399 80.417-95.829zM486.39 348.857l-80.417 95.83-19.715-16.4 80.416-95.829z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.6 236.68c4.592 36.974 11.297 78.175 68.199 82.455 21.328 1.278 62.817-5.074 77.061-63.19 18.688-55.829 74.975-71.88 113.28-41.613 21.718 14.166 27.727 36.666 29.283 53.557-1.739 54.243-32.874 101.2-72.823 122.14-45.93 27.3-109.56 27.87-165.3-13.49-25.12-23.57-60.219-67.02-49.7-139.86z",
    fill: "#3d5897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.91 370.59l78.734 67.661-14.591 16.997-87.156-71.851 23.013-12.807z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.887 357.197l83.002 97.335-19.937 17-83.002-97.334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16.188 437.25l78.602-67.814 14.641 16.953-83.996 75.519-9.247-24.659z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.672 333.696l83.003 97.334-19.937 17-83.002-97.334zM-30.033 381.199l83.002 97.334-19.936 17L-49.97 398.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKr);
export default __webpack_public_path__ + "static/media/kr.712af9ed639419f010dd4f9014538b55.svg";
export { ForwardRef as ReactComponent };